export default "__VITE_ASSET__b2eb8838__"